import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem } from '../../../__styling'
import { AppContentSection } from '../../components/StyledAppContentSection.styled'
import { InnerAppDownloadTextSection } from '../../components/StyledAppDownloadSection.styled'
import {
    StyledAppDownloadSubText,
    StyledAppDownloadTitle,
} from '../../components/StyledAppDownloadText.styled'

export const AppDownloadContentSectionBottom = styled(AppContentSection)(({ theme }) => ({
    width: "100%",

    // Tablet or larger sizing
    [breakpoint('sm')]: {
        width: "100%",
        padding: calcRem(0, 64),
        flexDirection: 'row',
    },

    // Desktop sizing
    [breakpoint('xl')]: {
        width: theme.siteMetrics.mainContentWidth,
    },


}))

export const AppDownloadSection = styled('div')({
    width: '100%',
    height: 'fit-content',
    backgroundColor: tokens.thenightly.colors.palette.white,

    zIndex: 1,
    position: 'relative',

    padding: calcRem(64, 16),

    [breakpoint('sm')]: {
        padding: calcRem(96, 0),
    },
})

export const InnerAppDownloadTextSectionBottom = styled(
    InnerAppDownloadTextSection,
)({
    // Display a full width & smaller gap on mobile devices
    width: '100%',
    gap: calcRem(16),

    // Tablet or larger styling
    [breakpoint('sm')]: {
        width: '100%',
        gap: calcRem(20),
    },
})

export const StyledAppDownloadTitleBottom = styled(StyledAppDownloadTitle)({
    color: tokens.thenightly.colors.palette.neutral[100],

    // Mobile styling
    fontSize: calcRem(20),
    lineHeight: calcRem(24),

    // Tablet or larger styling
    [breakpoint('sm')]: {
        fontSize: calcRem(22),
        fontWeight: 700,
        lineHeight: calcRem(32),
    },
})

export const StyledAppDownloadSubTextBottom = styled(StyledAppDownloadSubText)({
    color: tokens.thenightly.colors.palette.neutral[70],

    // Mobile styling
    fontSize: calcRem(16),
    lineHeight: "150%",

    // Tablet or larger styling
    [breakpoint('sm')]: {
        fontSize: calcRem(16),
        lineHeight: "150%",
    },
})

